export const GRID_MAX_WIDTH = 3840;
export const MAX_COLUMN_COUNT = 10;
export const GUTTER = 16;
export const ITEM_MIN_WIDTH = 260;
export const ITEM_HEIGHT_GRID = 154;
export const ITEM_HEIGHT_LIST = 64;
export const HEADER_HEIGHT = 64;
export const FOOTER_HEIGHT = 64;
export const ITEM_VERTICAL_OFFSET = 32;
